import type { TypedSupabaseClient } from '../client';
import type { ISharingRepository, UpsertDocumentShareLinkInput } from '../../../interfaces/src';

// The generated Supabase types are hand-maintained & stale, so reach the new
// RPC through a narrow cast (same idiom as messaging-repository).
const anyRpc = (client: TypedSupabaseClient) =>
  (fn: string, args: Record<string, unknown>) =>
    (client as unknown as { rpc: (f: string, a: Record<string, unknown>) => Promise<{ data: unknown; error: unknown }> }).rpc(fn, args);

export class SupabaseSharingRepository implements ISharingRepository {
  constructor(private supabase: TypedSupabaseClient) {}

  async upsertDocumentShareLink(input: UpsertDocumentShareLinkInput): Promise<string> {
    const { data, error } = await anyRpc(this.supabase)('upsert_document_share_link', {
      p_code: input.code,
      p_bucket: input.bucket,
      p_path: input.path,
      p_signed_url: input.signedUrl,
      p_expires_at: input.expiresAt,
      p_doc_type: input.docType ?? null,
      p_doc_number: input.docNumber ?? null,
    });
    if (error) throw error;
    if (typeof data !== 'string' || !data) {
      throw new Error('upsert_document_share_link returned no code');
    }
    return data;
  }
}
